import React from 'react'
import {Snackbar,SnackbarContent} from '@material-ui/core/';

function Errormsg(props) {

    const [state] = React.useState({
        open: true,
        vertical: 'bottom',
        horizontal: 'center',
      });
    
      const { vertical, horizontal } = state;


    return (

        <Snackbar 
        open={props.open}
        style={{ borderRadius : '1rem' }}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
        >
        <SnackbarContent style={{
            backgroundColor : '#d32f2f'
        }}
        message={props.msg}
        />
        
        </Snackbar>

    )
}

export default Errormsg
